const site = {
  siteId: 1,
  siteIdentify: "46317460b85eb60d2ed54ea2d0ea0392"
};

const channel = {
  ...site,
  channelId: 999,
  channelIdentify: "dev-channel"
};

const options = {
  ...channel,
  style: "",
  conditionId: 0
};

export default {
  boards: {
    8100: {
      ...options,
      boardId: 8102,
      boardIdentify: "pc_c_companylist_powerbroadcast",
      typeId: 100,
      style: "",
      lowerLimit: 3,
      upperLimit: 3,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "強力放送強力放送強力放送強力放送強力放送強力放送強力放送強力放送強力放送",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "強力放送強力放送強力放送強力放送強力放送強力放送強力放送強力放送強力放送",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        }
      ]
    },
    9100: {
      ...options,
      boardId: 9102,
      boardIdentify: "pc_c_companylist_sponsor_company",
      typeId: 100,
      style: "",
      lowerLimit: 3,
      upperLimit: 3,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/24/148418/516e0a72-38ea-4c06-bcd2-cb973fa84f6f/0.jpg",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/372/148419/95a84325-0b16-4238-b5e8-0a1991414ffc/0.jpg",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        }
      ]
    },
    9101: {
      ...options,
      boardId: 9101,
      boardIdentify: "pc_c_companylist_keywords_job",
      typeId: 101,
      style: "",
      lowerLimit: 3,
      upperLimit: 3,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element: "https",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 1,
              sort: 2,
              element:
                "https://material.adsmart.104.com.tw/24/148418/516e0a72-38ea-4c06-bcd2-cb973fa84f6f/0.jpg",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element: "https",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 2,
              element:
                "https://material.adsmart.104.com.tw/372/148419/95a84325-0b16-4238-b5e8-0a1991414ffc/0.jpg",
              type: "TEXT",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        }
      ]
    },
    8102: {
      ...options,
      boardId: 8102,
      boardIdentify: "pc_c_companylist_topbanner",
      typeId: 102,
      style: "",
      lowerLimit: 3,
      upperLimit: 3,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/24/148418/516e0a72-38ea-4c06-bcd2-cb973fa84f6f/0.jpg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/372/148419/95a84325-0b16-4238-b5e8-0a1991414ffc/0.jpg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        },
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/318/148289/22b69043-7aa6-4520-8a77-26a4c0ee623b/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/374/148290/80000981-5651-44bb-8a0c-7c2018a80d4e/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        }
      ]
    },
    9102: {
      ...options,
      boardId: 9102,
      boardIdentify: "pc_c_companylist_skyscraper",
      typeId: 102,
      style: "",
      lowerLimit: 3,
      upperLimit: 3,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/318/148289/22b69043-7aa6-4520-8a77-26a4c0ee623b/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/374/148290/80000981-5651-44bb-8a0c-7c2018a80d4e/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        },
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/318/148289/22b69043-7aa6-4520-8a77-26a4c0ee623b/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/374/148290/80000981-5651-44bb-8a0c-7c2018a80d4e/0.jpeg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            }
          ]
        }
      ]
    },
    9106: {
      ...options,
      boardId: 9106,
      boardIdentify: "pc_c_industry_retailservice",
      typeId: 106,
      style: "",
      lowerLimit: 1,
      upperLimit: 1,
      materials: [
        {
          shelfId: 409384,
          jobsource: "AD_409384_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/396/138179/fd13a32d-6168-414e-8ed9-3e415835a545/0.jpg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 1,
              sort: 2,
              element: "新人展",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 3,
              element: "台北旅店集團",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 4,
              element: "福薪報到",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 5,
              element: "台北市、台中市",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 6,
              element: "旅館業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 7,
              element:
                "台北旅店集團旗下有喜瑞、丹迪和新驛三個品牌，翻轉傳統經營思維，將旅館作為文化創意的平台。我們不斷求新求變，創造年輕活潑的企業文化，把每位員工都視為最重要的資產，期許全體員工一起成長前進！",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 8,
              element: "無經驗可科系不拘",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 9,
              element: "順暢的升遷管道",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 10,
              element: "薪資福利優於同業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 11,
              element: "五星級教育訓練計畫",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/396/138179/fd13a32d-6168-414e-8ed9-3e415835a545/0.jpg",
              type: "IMAGE",
              link: "https://www.104.com.tw/company/dc9cuy0"
            },
            {
              typeGroupNo: 2,
              sort: 2,
              element: "新人展",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 3,
              element: "台北旅店集團",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 4,
              element: "福薪報到",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 5,
              element: "台北市、台中市",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 6,
              element: "旅館業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 7,
              element:
                "台北旅店集團旗下有喜瑞、丹迪和新驛三個品牌，翻轉傳統經營思維，將旅館作為文化創意的平台。我們不斷求新求變，創造年輕活潑的企業文化，把每位員工都視為最重要的資產，期許全體員工一起成長前進！",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 8,
              element: "無經驗可科系不拘",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 9,
              element: "順暢的升遷管道",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 10,
              element: "薪資福利優於同業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 11,
              element: "五星級教育訓練計畫",
              type: "TEXT",
              link: ""
            }
          ]
        }
      ]
    },
    9107: {
      ...options,
      boardId: 9107,
      boardIdentify: "pc_c_industry_retailservice_card",
      typeId: 107,
      style: "",
      lowerLimit: 1,
      upperLimit: 1,
      materials: [
        {
          shelfId: 410410,
          jobsource: "AD_410410_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/410/143859/b0a1915a-19f9-4a16-8a44-9c1e5d2f0e68/0.jpg",
              type: "IMAGE",
              link: "https://events.104.com.tw/dechuantea/20230612094500/"
            },
            {
              typeGroupNo: 1,
              sort: 2,
              element: "新人展",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 3,
              element: "王德傳茶莊",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 4,
              element: "台北市、新北市",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 5,
              element: "百貨相關業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 1,
              sort: 6,
              element: "讓我們一起向世界介紹台灣茶！",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element:
                "https://material.adsmart.104.com.tw/410/143859/b0a1915a-19f9-4a16-8a44-9c1e5d2f0e68/0.jpg",
              type: "IMAGE",
              link: "https://events.104.com.tw/dechuantea/20230612094500/"
            },
            {
              typeGroupNo: 2,
              sort: 2,
              element: "新人展",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 3,
              element: "王德傳茶莊",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 4,
              element: "台北市、新北市",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 5,
              element: "百貨相關業",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 6,
              element: "讓我們一起向世界介紹台灣茶！",
              type: "TEXT",
              link: ""
            }
          ]
        }
      ]
    },
    9108: {
      ...options,
      boardId: 9108,
      boardIdentify: "pc_c_industry_company_tag",
      typeId: 108,
      style: "",
      lowerLimit: 1,
      upperLimit: 1,
      materials: [
        {
          shelfId: 410412,
          jobsource: "AD_410412_",
          contents: [
            {
              typeGroupNo: 1,
              sort: 1,
              element: "福薪報到",
              type: "TEXT",
              link: "https://serviceindustry.events.104.com.tw/"
            },
            {
              typeGroupNo: 1,
              sort: 2,
              element: "86125275000",
              type: "TEXT",
              link: ""
            },
            {
              typeGroupNo: 2,
              sort: 1,
              element: "福薪報到",
              type: "TEXT",
              link: "https://serviceindustry.events.104.com.tw/"
            },
            {
              typeGroupNo: 2,
              sort: 2,
              element: "86125275000",
              type: "TEXT",
              link: ""
            }
          ]
        }
      ]
    }
  },
  token: "$token"
};
